export function preparationStepState(journey:{stage:number;complete:boolean;confirmedStages?:number[];explicitStages?:boolean},index:number):'done'|'current'|'pending' {
 if(journey.explicitStages)return journey.confirmedStages?.includes(index)?'done':index===journey.stage?'current':'pending';
 if(journey.complete)return 'done';
 if(index===journey.stage)return 'current';
 return index<journey.stage||journey.confirmedStages?.includes(index)?'done':'pending';
}
